// const hostUrl = 'http://localhost:9090/tzg/';

const hostUrl = 'https://tzg.topaz-soft.com/tzg/';
export default {
  hostUrl,
}



// WEBPACK FOOTER //
// ./src/global.js